export default {"src":"/_next/static/media/external-link.ed22d7c2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};